import courseraPlusExperiments from 'bundles/epic/clients/__generated__/courseraPlus';

const REDESIGN_EXPERIMENT_KEY = 'isCourseraPlusRedesignLandingPageEnabled';

/**
 * Impresses the user into the experiment *and* returns their variant.
 */
export const generateRedesignExperimentImpression = (): boolean => courseraPlusExperiments.get(REDESIGN_EXPERIMENT_KEY);

/**
 * Reads the user's impression in the experiment without impressing them
 */
export const getIsRedesignExperimentEnabled = (): boolean => courseraPlusExperiments.preview(REDESIGN_EXPERIMENT_KEY);
